import { CascaderOptionType } from 'antd/lib/cascader'

import { CompanyAndBu, EmployeeLevelEnum } from '../../types'

export enum EmployeeTabs {
  Active = 'employee-active',
  Resigned = 'employee-resigned',
}

export type EmployeeSelectorValue = {
  companyId: string
  buId: string
  isAllBu: boolean
}

export interface EmployeeStoreState {
  storeInitialized: boolean
  activeTab: EmployeeTabs
  companiesAndBu: CompanyAndBu[]
  companiesAndBuSelected: CascaderOptionType[]
  selected: EmployeeSelectorValue
  employeeLevels: EmployeeLevelEnum[]

  initStore: (companiesAndBu: CompanyAndBu[], employeeLevels: EmployeeLevelEnum[]) => void
  setActiveTab: (activeTab: EmployeeTabs) => void
  setSelected: (companyId: string, buId: string) => void
}
